export const DownloadIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6.5L7 9.5L10 6.5"
      stroke="#0957FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 0.5V9.5"
      stroke="#0957FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 13.5H10.5"
      stroke="#0957FF"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
